import ChatMobileView from './ChatMobileView';

export default ChatMobileView;
